import logoWithNameSrc from "@/assets/logo-with-name.png";
import iconSrc from "@/assets/icon.png";

export function EngiCoroIcon({ className = "w-16 h-16" }: { className?: string }) {
  return (
    <img
      src={iconSrc}
      alt="EngiCoro"
      className={className}
      style={{ objectFit: "contain" }}
    />
  );
}

export function EngiCoroLogo({ className = "h-12" }: { className?: string }) {
  return (
    <img
      src={logoWithNameSrc}
      alt="EngiCoro Flow Weaver"
      className={className}
      style={{ objectFit: "contain" }}
    />
  );
}
